import { requestTimeout, handleResponse } from '../helpers'

const apiUrl = process.env.REACT_APP_API_URL
const accessToken = process.env.REACT_APP_ACCESS_TOKEN
const apiMaxTime = process.env.REACT_APP_API_EXEC_TIME

const base_uri = 'clientCredentials'
const types_uri = 'credentialTypes'

export const clientCredentialsApi = {
    _get,
    _create,
    _regenerate,
    _delete,
    _getTypes,
}

function headers() {
    const token = localStorage.getItem(accessToken)
    return { 'Content-Type': 'application/json', 'Accept': 'application/json', 'Authorization': 'Bearer ' + token }
}

async function _get(clientId) {
    const requestOptions = { method: 'GET', headers: headers() }
    const url = apiUrl + base_uri + (clientId ? `?client_id=${clientId}` : '')
    return requestTimeout(apiMaxTime, fetch(url, requestOptions)).then(handleResponse)
}

async function _create(data) {
    const requestOptions = { method: 'POST', headers: headers(), body: JSON.stringify(data) }
    return requestTimeout(apiMaxTime, fetch(apiUrl + base_uri + '/create', requestOptions)).then(handleResponse)
}

async function _regenerate(id) {
    const requestOptions = { method: 'PUT', headers: headers() }
    return requestTimeout(apiMaxTime, fetch(apiUrl + base_uri + '/update/' + id, requestOptions)).then(handleResponse)
}

async function _delete(id) {
    const requestOptions = { method: 'DELETE', headers: headers() }
    return requestTimeout(apiMaxTime, fetch(apiUrl + base_uri + '/delete/' + id, requestOptions)).then(handleResponse)
}

async function _getTypes() {
    const requestOptions = { method: 'GET', headers: headers() }
    return requestTimeout(apiMaxTime, fetch(apiUrl + types_uri, requestOptions)).then(handleResponse)
}
